import * as Yup from "yup";
import Package from "../enum/package.enum";
import Source from "../enum/source.enum";

const subUserSchema = Yup.object().shape({
  firstName: Yup.string().default("").nullable(),
  lastName: Yup.string().default("").nullable(),
  createdAt: Yup.string().default("").nullable(),
  email: Yup.string().email("Invalid email format").default("").nullable(),
  source: Yup.mixed().oneOf(Source).default("web").nullable(),
  package: Yup.string().oneOf(Package).default("").nullable(),
  targetLanguage: Yup.string().default("").nullable(),
  currentLevel: Yup.string().default("").nullable(),
  primaryGoal: Yup.string().default("").nullable(),
  nativeLanguage: Yup.string().default("").nullable(),
  practiceFrequency: Yup.string().default("").nullable(), // Adjust this according to mapLabelToKey return type
  mute: Yup.boolean().default(false),
  sentenceModeMute: Yup.boolean().default(false),
  hadPremium: Yup.boolean().default(false),
  interfaceLanguage: Yup.string().default("").nullable(),
  isSuggest: Yup.boolean().default(false),
  isHandsFree: Yup.boolean().default(false),
  isHandsFreeCallMode: Yup.boolean().default(false),
  isHandsFreeSentenceMode: Yup.boolean().default(false),
  isDarkMode: Yup.boolean().default(false),
  chatName: Yup.string().default("").nullable(),
  speechSpeed: Yup.number().default(1),
  newsletter: Yup.boolean().default(false),
  timeZone: Yup.string().default("UTC+00:00").nullable(),
  handsFreeInterval: Yup.number().default(3),
  handsFreeIntervalCallMode: Yup.number().default(3),
  handsFreeIntervalSentenceMode: Yup.number().default(3),
  fontSize: Yup.number().default(0),
  uiSound: Yup.boolean().default(false),
  seenTutorial: Yup.boolean().default(false),
  eligibleForRefund: Yup.boolean().default(false),
  abTesting: Yup.object()
    .shape({
      abTestingVersion: Yup.string().default("").nullable(),
      abTestingVersionSlot2: Yup.string().default("").nullable(),
      abTestingVersionSlot3: Yup.string().default("").nullable(),
      abTestingVersionSlot4: Yup.string().default("").nullable(),
      abTestingVersionSlot5: Yup.string().default("").nullable(),
      abTestingVersionSlot6: Yup.string().default("").nullable(),
      abTestingVersionSlot7: Yup.string().default("").nullable(),
      abTestingVersionSlot8: Yup.string().default("").nullable(),
      abTestingVersionSlot9: Yup.string().default("").nullable(),
      abTestingVersionSlot10: Yup.string().default("").nullable(),
      abTestingVersionSlot11: Yup.string().default("").nullable(),
      abTestingVersionSlot12: Yup.string().default("").nullable(),
      abTestingVersionSlot13: Yup.string().default("").nullable(),
      abTestingVersionSlot14: Yup.string().default("").nullable(),
      abTestingVersionSlot15: Yup.string().default("").nullable(),
      abTestingVersionSlot16: Yup.string().default("").nullable(),
      abTestingVersionSlot17: Yup.string().default("").nullable(),
      abTestingVersionSlot18: Yup.string().default("").nullable(),
      abTestingVersionSlot19: Yup.string().default("").nullable(),
      abTestingVersionSlot20: Yup.string().default("").nullable(),
    })
    .nullable(),
});

export default subUserSchema;
